import React, { useEffect, useState } from 'react'
import { Select, useTraversal } from '@guillotinaweb/react-gmi'
import { Input } from 'antd'

import { useStore } from '../'

// Google Maps API has a cost per request, so we need to upload the images on save
// when the cellar.googlemap_url is changed
const GOOGLE_MAPS_KEY = 'AIzaSyCjX3Uslfba9FtQxkeUAN2tKkwW9TIFWGY'
const EXAMPLE_MAP_URL =
  'https://www.google.com/maps/@41.4564908,2.1829595,16.38z'

export default function Location({ cellar }) {
  const Ctx = useTraversal()
  const [cp, setCp] = useStore.codigo_postal(cellar.codigo_postal)
  const [locality, setLocality] = useStore.localidad(cellar.localidad)
  const [province, setProvince] = useStore.provincia(cellar.id_provincia)
  const [country, setCountry] = useStore.pais(cellar.id_pais)
  const [mapLink, setMapLink] = useStore.googlemap_url(
    cellar.googlemap_url || ''
  )
  const [address, setAddress] = useStore.direccion(cellar.direccion)
  const [fieldConsts, setFieldConsts] = useState({
    provincias: [],
    paises: [],
  })

  const { latitude, longitude, zoom, img } = getGoogleMapsDataFromURL(mapLink)

  useEffect(() => {
    async function load() {
      const r = await Ctx.client.rest.get('@field-constants')
      if (r.status === 200) {
        const data = await r.json()
        setFieldConsts(data)
      } else {
        console.error(r.text())
      }
    }
    load()
  }, [Ctx.path])

  return (
    <>
      <h2 className="title is-size-6">
        <i className="icon icon-marker" />
        Town
      </h2>
      <div style={{ fontSize: 14, margin: '10px 0' }}>Address:</div>
      <Input value={address} onChange={(e) => setAddress(e.target.value)} />
      <div style={{ fontSize: 14, margin: '10px 0' }}>Postal code:</div>
      <Input value={cp} onChange={(e) => setCp(e.target.value)} />
      <div style={{ fontSize: 14, margin: '10px 0' }}>Town:</div>
      <Input value={locality} onChange={(e) => setLocality(e.target.value)} />
      <div style={{ fontSize: 14, margin: '10px 0' }}>Province:</div>
      <Select
        value={province}
        onChange={(e) => {
          setProvince(e.target.value)
        }}
        options={[
          { value: null, text: '<Sin provincia>' },
          ...fieldConsts.provincias.map((p) => ({ value: p, text: p })),
        ]}
      />
      <div style={{ fontSize: 14, margin: '10px 0' }}>Country:</div>
      <Select
        value={country}
        onChange={(e) => {
          setCountry(e.target.value)
        }}
        options={fieldConsts.paises.map((p) => ({ value: p, text: p }))}
      />

      <hr />

      <div style={{ fontSize: 14, margin: '10px 0' }}>Display map:</div>

      <span style={{ fontSize: 12, color: 'grey', width: 80 }}>
        Paste here a{' '}
        <a rel="noopener noreferrer" target="_blank" href={EXAMPLE_MAP_URL}>
          Google Map
        </a>{' '}
        Link (with the absolute URL, from https://www.google.com/maps/@...)
      </span>
      <Input
        placeholder={EXAMPLE_MAP_URL}
        value={mapLink}
        onChange={(e) => setMapLink(e.target.value)}
      />

      {latitude && longitude && zoom && (
        <>
          <div style={{ fontSize: 12, margin: '10px 0' }}>Map image:</div>

          <a rel="noopener noreferrer" target="_blank" href={mapLink}>
            <img key={latitude + longitude + zoom} alt="map" src={img} />
          </a>
        </>
      )}
    </>
  )
}

export function getGoogleMapsDataFromURL(url) {
  let [latitude, longitude, zoom] = url.split('/@')[1]?.split(',') || []

  zoom = zoom?.split('z')[0] || 16

  function getMapImg(size) {
    return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=${size}&key=${GOOGLE_MAPS_KEY}&markers=color:red%7C${latitude},${longitude}`
  }

  return {
    latitude,
    longitude,
    zoom,
    img: getMapImg('600x400'),
  }
}
